'use strict';

customerZone.config(['configProvider', '$sceDelegateProvider', function (configProvider, $sceDelegateProvider) {
    var config = configProvider.$get();
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our normal domain. If the site is loaded through google-translate or the likes, this
        // will prevent resources to break
        config.baseUrl+'/**']);
}]);
